/* eslint-disable */
(function () {
  "use strict";

  var MAPTILER_PLACEHOLDER = "get_your_own_OpIi9ZULNHzrESv6T2vL";
  var MARKER_SIZE = { width: 40, height: 50 };

  const mapDiv = document.getElementById("map-canvas");

  let avgLng = 46.2165999;
  let avgLat = 6.1979656;

  if (mapDiv) {
	  var MARKERS = [];

    // Add DOM markers to array
    document.querySelectorAll(".large-map__marker").forEach(function (el) {
      MARKERS.push({
        lng: parseFloat(el.dataset.lng),
        lat: parseFloat(el.dataset.lat),
        name: el.dataset.name,
        url: 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(el.dataset.address) + '&query_place_id=' + encodeURIComponent(el.dataset.lat + ',' + el.dataset.lng),
      });
    });

    if (MARKERS.length > 0) {
      avgLng = MARKERS.reduce((sum, m) => sum + m.lng, 0) / MARKERS.length;
      avgLat = MARKERS.reduce((sum, m) => sum + m.lat, 0) / MARKERS.length;
    }
  }

  function createMarkerImages(markerIcon, markerIconHover) {
    var transition = "0.3s all";
    var imgDefault = document.createElement("img");
    imgDefault.src = markerIcon;
    imgDefault.alt = "";
    imgDefault.setAttribute("width", MARKER_SIZE.width);
    imgDefault.setAttribute("height", MARKER_SIZE.height);
    imgDefault.style.cssText =
      "position:absolute;left:0;top:0;width:" +
      MARKER_SIZE.width +
      "px;height:" +
      MARKER_SIZE.height +
      "px;transition:" +
      transition +
      ";";
    var imgHover = document.createElement("img");
    imgHover.src = markerIconHover;
    imgHover.alt = "";
    imgHover.setAttribute("width", MARKER_SIZE.width);
    imgHover.setAttribute("height", MARKER_SIZE.height);
    imgHover.style.cssText =
      "position:absolute;left:0;top:0;width:" +
      MARKER_SIZE.width +
      "px;height:" +
      MARKER_SIZE.height +
      "px; transition:" +
      transition +
      ";";
    return { defaultImg: imgDefault, hoverImg: imgHover };
  }

  function initMap() {
    if (typeof cf_echami_map === "undefined") {
      console.warn("cf_echami_map not loaded yet");
      return setTimeout(initMap, 100); // Retry
    }

    var container = document.getElementById("map-canvas");
    if (!container) {
      return;
    }

    if (typeof cf_echami_map === "undefined" || !cf_echami_map.maptilerKey) {
      container.innerHTML =
        '<p style="padding:2em;text-align:center;color:#666;">' +
        (cf_echami_map && cf_echami_map.noKeyMessage
          ? cf_echami_map.noKeyMessage
          : "MapTiler API key required.") +
        "</p>";
      return;
    }

    var mapStyleUrl = cf_echami_map.mapStyleUrl;
    var maptilerKey = cf_echami_map.maptilerKey;
    var markerIcon = cf_echami_map.markerIcon;
    var markerIconHover = cf_echami_map.markerIconHover;

    fetch(mapStyleUrl)
      .then(function (res) {
        return res.text();
      })
      .then(function (styleText) {
        var styleJson = JSON.parse(
          styleText.replace(
            new RegExp(
              MAPTILER_PLACEHOLDER.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
              "g",
            ),
            maptilerKey,
          ),
        );

        var zoom =
          typeof cf_echami_map !== "undefined" &&
          cf_echami_map.zoom != null &&
          !isNaN(cf_echami_map.zoom)
            ? Math.max(0, Math.min(22, Number(cf_echami_map.zoom)))
            : 10;
        var map = new maplibregl.Map({
          container: "map-canvas",
          style: styleJson,
          center: [avgLng, avgLat],
          zoom: zoom,
          attributionControl: false,
        });

        map.scrollZoom.disable();

        map.addControl(new maplibregl.NavigationControl(), "top-right");

        // Add markers (crossfade: two stacked images, no disappear)
        MARKERS.forEach(function (m) {
          var el = document.createElement("div");
          el.className = "large-map__marker";
          el.style.cssText =
            "cursor:pointer; width:" +
            MARKER_SIZE.width +
            "px; height:" +
            MARKER_SIZE.height +
            "px;";

          var imgs = createMarkerImages(markerIcon, markerIconHover);
          el.appendChild(imgs.hoverImg);
          el.appendChild(imgs.defaultImg);
          
		
		let tmp = document.createElement("div");
		  tmp.className = "marker-label";
          tmp.innerHTML = m.name;
          el.appendChild(tmp);

          el.addEventListener("mouseenter", function () {
            imgs.defaultImg.style.opacity = "0";
          });
          el.addEventListener("mouseleave", function () {
            imgs.defaultImg.style.opacity = "1";
          });

          el.addEventListener('click', function() {
                                var targetUrl = m.url;
                                if (targetUrl) {
                                    window.open(targetUrl, '_blank');
                                }
                            });

          new maplibregl.Marker({ element: el })
            .setLngLat([m.lng, m.lat])
            .addTo(map);
        });
      })
      .catch(function (err) {
        console.warn("cf_echami map: could not load style", err);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMap);
  } else {
    initMap();
  }
})();

